import React, {useRef, useState} from 'react'
import styles from './entry.module.css'
import {useTranslation} from 'react-i18next'
import {Button, Col, Input, message} from 'antd'
import {showMessage} from '../../../common/message'
import PopupSpinner from '../../molecules/spinner/PopupSpinnerView'
import {useNavigate} from "react-router-dom";

export const SearchScreen = () => {
    const navigate = useNavigate()
    const {t} = useTranslation('tracking')
    const [messageApi, messageHolder] = message.useMessage();
    const trackingRef = useRef('')
    const [loading, setLoading] = useState(false)

    const handleChangeDelivery = (e: any | { target: { value: string } }) => {
        trackingRef.current = e.target.value
    }

    const handleSearch = () => {
        console.log("handleSearch", trackingRef.current)
        //공동현관 비밀번호 선택시
        if (!trackingRef.current) {
            showMessage(messageApi, t('popup.error.tracking.empty'))
            return
        }
        setLoading(true)
        navigate(`/tracking/${trackingRef.current}`)
    }

    return (
        <Col className={'inner-container column ' + styles.searchInner}>
            {messageHolder}
            <div className={styles.title}>
                <div className={'title'}>{t('search.subtitle')}</div>
                <div className={'body ' + styles.label}>{t('search.label')}</div>
            </div>
            <form
                onSubmit={handleSearch}>
                <Input
                    maxLength={24}
                    size={"large"}
                    defaultValue={''}
                    autoComplete={'off'}
                    autoFocus
                    placeholder={t('search.input.place')}
                    data-cy={'deliveryID'}
                    onChange={handleChangeDelivery}
                />
                <Button type={'primary'} size={"large"} block data-cy={'submitID'} className={styles.button}
                        onClick={handleSearch}>
                    {t('search.btn')}
                </Button>
            </form>
            {loading && <PopupSpinner/>}
        </Col>
    )
}